module.exports = __webpack_public_path__ + "img/20170704_135648_099.36e5c5da.jpg";